import React from "react";
import {graphql} from "gatsby";
import parse from "html-react-parser";
import {Asset} from "../../../../plugins/gatsby-plugin-atollon";
import StructuredText from "../custom-structured-text-renderer";

const ExpertiseBanner = ({title, richContent, image}) => {
    return (
      <section className='expertise-banner'>
        <div className='expertise-banner__inner'>
          <div className='expertise-banner__content'>
            <div className='expertise-banner__info' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
              {title && <h1>{parse(title)}</h1>}
              {richContent && <StructuredText data={richContent} />}
            </div>
          </div>
        </div>
        <div className='expertise-banner__image'>
          {image && <Asset asset={image} />}
        </div>
      </section>
    )
}

export default ExpertiseBanner

export const query = graphql`
 fragment ExpertiseBannerProps on DatoCmsExpertiseBanner {
  ... on DatoCmsExpertiseBanner {
    id
    title
    richContent {
      value
    }
    image {
      ...InternalAssetProps
    }
  }
}
`